module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('div', {
    staticClass: "hr"
  }, [_c('p', {
    staticClass: "CT"
  }, [_vm._v("Rafi")]), _vm._v(" "), _c('p', {
    staticClass: "CIT"
  }, [_vm._v("Rafi didn’t like being proved wrong, but Snout pointed out the blood spatter from the initial hit and even tracked back to the place the girl had stood when she took the ill-fated shot. Both were on the public side of the river. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It was a right fine shot, if I may say so,” the tracker said as he scratched his perfectly average nose. His nickname hailed from his ability to sniff out any trail. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It wasn’t a kill, Snout.” Rafi looked across the orchard but silently agreed with the tracker. With the low-hanging branches and shadows, it would have been a difficult mark for any man in his guard. “If she’d only waited for it to turn broadside.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Then she wouldn’t be hurt, and I wouldn’t feel such a fool. ")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Dom, send riders to town. Have them spread word that we found a girl lost in the woods. Say she was injured and is under our care,” Rafi said as he snapped a fallen twig in half. “I don’t expect anyone to claim the figureless urchin, but I’ve already been wrong once today.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dom snorted. “I’ll mark it in my journal, for I’m certain it will never happen again.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Rafi punched his brother in the shoulder hard enough to knock the younger boy back a step. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Careful with those fists, brother.” Dom rubbed the spot theatrically. “They tend to get you in trouble. Right, Snout?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The tracker held back a smile, but only barely. “Is there anything else, Lord Rafael?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“If anyone does claim the girl, please escort them back to the manor.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yessir.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Well . . .” Dom slapped his riding gloves against his palm as he watched Snout return to his mount. “I’d be happy to serve as your Punisher. I could pull my punches a bit, and perhaps save you some pain.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Typical Dom, always searching for the easiest way out of any problem. Rafi knew he could agree, that his mother would let him choose the Punisher. But it was a point of pride to select someone to dole out the blows—four times as many as he’d unjustly given—who could actually hurt him. Dom was strong for a sixteen-year-old, but he wasn’t the Punisher Rafi had in mind. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There was a lesson in this, and Rafi wanted his stupidity to teach his younger brother the cost of mistakes. “If we don’t uphold the law, then no one will.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s archaic. Can’t we pay her off?” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s honorable,” Rafi corrected. “No man should be able to take advantage of the weak. I’m going to ask Captain Alouette to serve as my Punisher.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dom cringed. “I didn’t expect to take your title, but if you’re offering it up . . .” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll survive.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’ll pray for you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("I’ll need it.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-042050c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch008.vue
// module id = 87
// module chunks = 0